import React from "react";
import p1 from "./images/p1.jpg";
import p2 from "./images/p2.jpg";
import p3 from "./images/p3.jpg";

const MemberData=[
    {
        id:1,
        img:p1,
        name:"Michael Lewis",
        post:"Senior Manager",
    },
    {
        id:2,
        img:p2,
        name:"Peter Jones",
        post:"PR Manager",
    },
    {
        id:3,
        img:p3,
        name:"Jenny Martin",
        post:"Clients Manager",
    }
]
export default MemberData;